import type { I18n } from '@change-corgi/core/i18n';

import { craftStarterEmail } from './craftStarterEmail';

type Dm = Readonly<{ email: string; displayName: string }>;

type Context = Readonly<{
	ask: string;
	slug: string;
	signatureCount: string;
	starterDisplayName: string;
}>;

export const buildDmEmailHref = (dm: Dm, context: Context, translate: I18n['translate']): string => {
	const replacements = {
		dmName: dm.displayName,
		ask: context.ask,
		signatureCount: context.signatureCount,
		petitionUrl: `https://www.change.org/p/${context.slug}?utm_source=starter_emails_dm`,
		starterDisplayName: context.starterDisplayName,
	};
	const subject = translate('corgi.petition.starter_dashboard.shared.email_dm.subject', replacements);
	const body = [
		translate('corgi.petition.starter_dashboard.shared.email_dm.body.paragraph_1', replacements),
		translate('corgi.petition.starter_dashboard.shared.email_dm.body.paragraph_2', replacements),
		translate('corgi.petition.starter_dashboard.shared.email_dm.body.paragraph_3', replacements),
	].join('\n\n');

	return craftStarterEmail({ dmEmail: dm.email, subject, body });
};
